export default __webpack_public_path__ + "static/media/tituloEN.3a2e06b0.png";